import React from 'react';
import { IconButton, MenuItem, Select, SelectChangeEvent } from '@mui/material';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import './HeatMapYearDropdown.scss';

interface Props {
  currentYear: string;
  setCurrentYear: (year: string) => void;
  selectedMonth: string | null;
  setSelectedMonth: (month: string | null) => void;
}

const HeatMapYearDropdown: React.FC<Props> = ({ currentYear, setCurrentYear }) => {
  const thisYear = new Date().getFullYear();
  const currentYearNumber = Number(currentYear);

  const years = Array.from({ length: thisYear - 2000 }, (_, i) => String(thisYear - i));

  const handleSelectChange = (event: SelectChangeEvent<unknown>) => {
    setCurrentYear(String(event.target.value));
  };

  const handleIncreaseYear = () => {
    if (currentYearNumber < thisYear) {
      setCurrentYear(String(currentYearNumber + 1));
    }
  };

  const handleDecreaseYear = () => {
    setCurrentYear(String(currentYearNumber - 1));
  };

  return (
    <div className="d-flex align-items-center justify-content-start heatmap_dropdown">
      <div className="d-flex flex-column" style={{ lineHeight: 1 }}>
        <IconButton
          size="small"
          onClick={handleIncreaseYear}
          disabled={currentYearNumber >= thisYear}
          sx={{ padding: '2px' }}
        >
          <KeyboardArrowUpIcon fontSize="small" className="heatmap_arrows_icons" />
        </IconButton>

        <IconButton size="small" onClick={handleDecreaseYear} sx={{ padding: '2px' }}>
          <KeyboardArrowDownIcon fontSize="small" className="heatmap_arrows_icons " />
        </IconButton>
      </div>
      <div className="heatmap_divider" />
      <Select value={currentYear} onChange={handleSelectChange} IconComponent={ExpandMoreIcon} className="year-select">
        {years.map(year => (
          <MenuItem key={year} value={year} sx={{ fontFamily: 'Poppins, sans-serif' }}>
            {year}
          </MenuItem>
        ))}
      </Select>
    </div>
  );
};

export default HeatMapYearDropdown;
